/**
 * Los envíos hechos desde plantillas: cuándo, de qué y cuántos documentos.
 * El avance de las firmas está en el detalle de cada envío.
 */
import { useNavigate } from 'react-router-dom'
import { Send } from 'lucide-react'
import { DataTable } from '@/components/ds/DataTable'
import { StatusBadge } from '@/components/ds/StatusBadge'
import { EmptyState } from '@/components/EmptyState'
import { formatDate, useTenantLocale } from '@/lib/locale'
import { useEnvios, type EnvioDocumentos } from '../../hooks/usePlantillasDocumentos'
import { ESTADOS_ENVIO } from './utilidades'

export default function EnviosTab() {
  const navigate = useNavigate()
  const locale = useTenantLocale()
  const { data: envios = [], isLoading } = useEnvios()

  return (
    <DataTable<EnvioDocumentos>
      rows={envios}
      rowKey={(e) => e.id}
      loading={isLoading}
      onRowClick={(e) => navigate(`/payroll/documents/batches/${e.id}`)}
      empty={<EmptyState icon={Send} size="sm" title="Todavía no hay envíos."
        hint="Se generan desde una plantilla activa, con «Generar»." />}
      columns={[
        {
          key: 'name', header: 'Documento', sortable: true, sortValue: (e) => e.name.toLowerCase(),
          render: (e) => (
            <div>
              <div className="text-content">{e.name}</div>
              <div className="text-xs text-content-muted">{e.created_by_name}</div>
            </div>
          ),
        },
        {
          key: 'created_at', header: 'Fecha', sortable: true, sortValue: (e) => e.created_at,
          render: (e) => formatDate(e.created_at, locale),
        },
        {
          key: 'docs', header: 'Documentos', numeric: true,
          render: (e) => (
            <span>
              {e.generated} de {e.total}
              {e.failed > 0 && <span className="text-warning-content"> · {e.failed} con error</span>}
            </span>
          ),
        },
        {
          key: 'status', header: 'Estado',
          render: (e) => <StatusBadge status={e.status} tone={ESTADOS_ENVIO[e.status].tone}
            label={ESTADOS_ENVIO[e.status].label} live={e.status === 'running'} />,
        },
      ]}
    />
  )
}
